import { FC } from 'react'
import styled from 'styled-components'
import { Text, TextColor } from './textStyles'
import { media } from '../../theme/breakpoints'
import React from 'react'

interface Props {
    color?: TextColor
    children: React.ReactNode
    className?: string
    id?: string
}

// Header1: xxxLarge (42px) → xLarge (24px) on mobile, xxLarge (30px) on tablet
const StyledHeader1 = styled(Text)`
    ${media.tablet} {
        font-size: ${(p) => 30 / p.theme.baseFontSize}em;
        line-height: ${(p) => 36 / 30}em;
    }
    ${media.mobile} {
        font-size: ${(p) => 24 / p.theme.baseFontSize}em;
        line-height: ${(p) => 28.8 / 24}em;
    }
`

// Header2: xxLarge (30px) → large (20px) on mobile, xLarge (24px) on tablet
const StyledHeader2 = styled(Text)`
    ${media.tablet} {
        font-size: ${(p) => 24 / p.theme.baseFontSize}em;
        line-height: ${(p) => 28.8 / 24}em;
    }
    ${media.mobile} {
        font-size: ${(p) => 20 / p.theme.baseFontSize}em;
        line-height: ${(p) => 24 / 20}em;
    }
`

// Header3: xLarge (24px) → medium (18px) on mobile, large (20px) on tablet
const StyledHeader3 = styled(Text)`
    ${media.tablet} {
        font-size: ${(p) => 20 / p.theme.baseFontSize}em;
        line-height: ${(p) => 24 / 20}em;
    }
    ${media.mobile} {
        font-size: ${(p) => 18 / p.theme.baseFontSize}em;
        line-height: ${(p) => 28.8 / 18}em;
    }
`

export const Header1: FC<Props> = ({
    children,
    className,
    color = 'primary',
}) => {
    return (
        <StyledHeader1
            size="xxxLarge"
            $weight="medium"
            color={color}
            className={className}
        >
            {children}
        </StyledHeader1>
    )
}

export const Header2: FC<Props> = ({
    children,
    className,
    color = 'primary',
}) => {
    return (
        <StyledHeader2
            size="xxLarge"
            $weight="medium"
            color={color}
            className={className}
        >
            {children}
        </StyledHeader2>
    )
}

export const Header3: FC<Props> = ({
    children,
    className,
    color = 'primary',
    id,
}) => {
    return (
        <StyledHeader3
            id={id}
            size="xLarge"
            $weight="bold"
            color={color}
            className={className}
        >
            {children}
        </StyledHeader3>
    )
}

export const Header4: FC<Props> = ({
    children,
    className,
    color = 'primary',
}) => {
    return (
        <Text size="large" $weight="medium" color={color} className={className}>
            {children}
        </Text>
    )
}
